import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { InspectionObservationPointsViewModel, ObservationMeasurementViewModel } from '../../../../inspection.model';
import { LoadingService } from '../../../../../../../shared/services/loading.service';
import { NewInspectionService } from '../../../../inpsection.service';
import { GETClickToEditComponent } from '../../../../../shared/click-to-edit/get-click-to-edit.component';

@Component({
  selector: 'measurement-on-observation',
  templateUrl: './measurement-on-observation.component.html',
  styleUrls: ['./measurement-on-observation.component.scss']
})
export class MeasurementOnObservationComponent implements OnInit {

  @Input()
  observationPoint: InspectionObservationPointsViewModel;
  @Input()
  isCreatingInspection = true;

  @Output()
  measurementChanged: EventEmitter<number> = new EventEmitter();




  @ViewChild('measurementEditInput')
  measurementInput: GETClickToEditComponent;

  eval:number
  measurementOnDisplay: ObservationMeasurementViewModel;
  oldReading: number;
  selectedMeasurementIndex: number;
  avg_measurement:number;
  constructor(private _loading: LoadingService,
    private inspectionService: NewInspectionService,
    ) { }
  ngOnInit() {
    this.avg_measurement = -1;
  //  console.log("this.observationPoint",this.observationPoint)
    if (this.observationPoint !== undefined
      && this.observationPoint.ObservationMeasurements !== undefined
      && this.observationPoint.ObservationMeasurements.length > 0) {

        //console.log("ObservationOPoingt",this.observationPoint)
this.observationPoint.ObservationMeasurements.map(x=>{
  x.ReadingPosition = x.ReadingPosition+1;
  
})
        
      this.measurementOnDisplay = this.observationPoint.ObservationMeasurements[0];
      this.oldReading = this.measurementOnDisplay.MeasurementReading;
     this.selectedMeasurementIndex = 1 ;
     
    }

    // if(this.observationPoint.ObservationTypeName=='Normal' && this.observationPoint.){


      if (this.observationPoint.MaxReadings > this.observationPoint.ObservationMeasurements.length) {
        var checkForFirst:Boolean;

        for (let index = this.observationPoint.ObservationMeasurements.length; index < this.observationPoint.MaxReadings; index++) {
        const newMeasurement = this.createMeasurement(this.observationPoint.ObservationMeasurements.length === undefined ? 1 : this.observationPoint.ObservationMeasurements.length+1  );
       //console.log("reading", newMeasurement, this.observationPoint.ObservationMeasurements)
        this.observationPoint.ObservationMeasurements.push(newMeasurement);
          
      
        this.selectedMeasurementIndex = newMeasurement.ReadingPosition;
        this.measurementOnDisplay = newMeasurement;
  
        if (!this.isCreatingInspection) {
          this._loading.startLoading();
           this.inspectionService.AddNewMeasurementReadingToObservationPointInspection
           (this.observationPoint.Id, 0, this.observationPoint.ObservationMeasurements.length-1)
           .subscribe(r => {
              this._loading.finishedLoading();
              //console.log(r);
              newMeasurement.Id = r.m_Item1;
           });
        }
       }
       
        
      }    else {
        console.log('Reached Max Capacity of MeasurementReadings');
      }

    if (this.measurementOnDisplay.MeasurementReading==0){
        this.measurementOnDisplay.MeasurementReading=null;
      }
    // }
   
    // if(this.observationPoint.ObservationPointId == 3){
    //   this.eval= this.observationPoint.ObservationMeasurements[0].MeasurementReading;
    // }
  }


  addNewMeasurementReading(observation: InspectionObservationPointsViewModel) {
    if (observation.MaxReadings > observation.ObservationMeasurements.length) {
      const newMeasurement = this.createMeasurement(observation.ObservationMeasurements.length === undefined ? 1 : observation.ObservationMeasurements.length+1  );
     // console.log("reading", newMeasurement, this.observationPoint.ObservationMeasurements)
      this.observationPoint.ObservationMeasurements.push(newMeasurement);
      this.selectedMeasurementIndex = newMeasurement.ReadingPosition;
      this.measurementOnDisplay = newMeasurement;


      if (!this.isCreatingInspection) {
        this._loading.startLoading();
         this.inspectionService.AddNewMeasurementReadingToObservationPointInspection
         (this.observationPoint.Id, 0, observation.ObservationMeasurements.length-1)
         .subscribe(r => {
            this._loading.finishedLoading();
            //console.log(r);
            newMeasurement.Id = r.m_Item1;
         });


      }
    }    else {
      console.log('Reached Max Capacity of MeasurementReadings');
    }
  }

  changeMpOnDisplay(measurement: ObservationMeasurementViewModel) {
    //console.log("measurement",measurement)
    this.measurementOnDisplay = measurement;
    this.selectedMeasurementIndex = measurement.ReadingPosition;

    this.measurementInput.data = measurement.MeasurementReading;
    this.measurementInput.updateDisplayVal();
    
    //console.log("measurementInput",this.measurementInput.data);
    //console.log("avg_measurement",this.avg_measurement);

    this.avg_measurement = -1
  }

  calculateAvg(measurements: ObservationMeasurementViewModel[]) {

    //console.log("calculateAvg")
    let total = 0;
    for ( let i = 0; i < measurements.length ; i++) {
      total += measurements[i].MeasurementReading;
    }
    const newDisplay = this.createMeasurement(999);
    this.selectedMeasurementIndex = 999;
    newDisplay.MeasurementReading =  total / measurements.length;
    this.avg_measurement = Number((total / measurements.length).toFixed(2))
    //console.log("newDisplay", this.avg_measurement)
  }
 
  calculateEval(event:any){
  //console.log("evallll",this.eval,event)
  this.updateComponentMeasurement(event.value);
  }

  updateComponentMeasurement(measurement: number ) {
    if(measurement==undefined){
      measurement= this.measurementOnDisplay.MeasurementReading;
    }
    if(measurement!=null && measurement!=0){
    this.inspectionService.updateMeasurementReadingOnObservationPoint(measurement, this.measurementOnDisplay.Id)
    .subscribe( a => {
      this.measurementChanged.emit(a);
        //console.log("aaaa",a);
    });
    }
    
    
  }
 
  createMeasurement(position: number): ObservationMeasurementViewModel {
    return {
      Id: 0,
      MeasurementReading: 0,
      ReadingPosition: position
    };
  }


}
